import {CtModelRouteData} from "@ctsolution/ct-framework";

export const OfferRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("offer");
